import { NgModule } from "@angular/core";
import { NumbersOnlyDirective } from "./numbers-only.directive";
import { PercentageInputDirective } from "./percentage-input.directive";
import { FloatDirective } from "./float.directive";
import { BlockCharDirective } from "./block-char.directive";
import { PhoneNumberOnlyDirective } from "./phone-number-only.directive";
import { CommonModule } from "@angular/common";
import { BlockQuotesDirective } from "./block-quotes.directive";
import { AlphaNumericDirective } from "./alpha-numeric.directive";

@NgModule({
  declarations: [
    NumbersOnlyDirective,
    PercentageInputDirective,
    FloatDirective,
    BlockCharDirective,
    PhoneNumberOnlyDirective,
    BlockQuotesDirective,
    AlphaNumericDirective
  ],
  imports:[
    CommonModule
  ],
  exports: [
    NumbersOnlyDirective,
    PercentageInputDirective,
    FloatDirective,
    BlockCharDirective,
    PhoneNumberOnlyDirective,
    BlockQuotesDirective,
    AlphaNumericDirective
  ]
})
export class DirectivesModule { }